import { Component, Vue } from 'vue-property-decorator'
import { evaluationEmailHistory } from '@/api'
@Component({ name: 'apply-info' })
export default class ApplyHistory extends Vue {
  private searchCourseCode = ''
  private searchStuName = ''
  private totalPage = 0
  private currentPage = 1
  private sendTime = []
  private applyInfoList = []

  async created () {
    await this.getHistoryList()
  }

  async getHistoryList () {
    const args = {
      studentName: this.searchStuName,
      courseCode: this.searchCourseCode,
      limit: 20,
      currentPage: this.currentPage,
      sendTimeStart: undefined,
      sendTimeEnd: undefined
    }

    if (this.sendTime.length > 0) {
      args.sendTimeStart = this.sendTime[0]
      args.sendTimeEnd = this.sendTime[1]
    }

    const res: any = await evaluationEmailHistory(args)
    if (!res.error) {
      this.$message({ type: 'success', message: '查询成功' })
    }
    const { historyList, allPage, currentPage } = res
    if (historyList.length === 0) {
      this.$message({ type: 'error', message: '未找到历史信息' })
    }

    this.applyInfoList = historyList
    this.totalPage = allPage
    this.currentPage = currentPage
  }

  private async searchBtnClick () {
    console.log('searchBtnClick', this.sendTime)
    await this.getHistoryList()
  }

  private async onPageChange () {
    console.log('onPageChange', this.currentPage)
    await this.getHistoryList()
  }
}
